import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.initialPage = this.props.page;
    }

    componentDidMount() {
        if (this.initialPage == 1) {
            this.props.getPage({ page: this.props.page + 1 });

            this.lastVisiblePage = this.props.page;
            this.direction = 'down';

            window.addEventListener('scroll', () => {
                const visiblePage = parseInt(this.getMostVisibleElement().dataset.page);

                if (visiblePage != this.lastVisiblePage) {
                    this.lastVisiblePage = visiblePage;

                    if (visiblePage != this.props.page && this.props.articles[visiblePage]) {
                        this.props.setPage({ page: visiblePage });
                    }

                    const pageToGet = visiblePage + 1;

                    if (pageToGet <= this.props.pages && !this.props.articles[pageToGet]) {
                        this.props.getPage({ page: pageToGet });
                    }
                }
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.articles != this.props.articles) {
            return true;
        }

        return false;
    }

    render({ articles }) {
        return (
            <article-list>
                {Object.keys(articles).map(key => (
                    <pager data-page={key}>
                        {articles[key].map((article, index) => this.renderArticle(article, index))}
                    </pager>
                ))}
            </article-list>
        );
    }

    renderArticle = (article, index) => {
        const image_slug = article.image_slug || 'tarot-hand';
        const img_url = `https://gfx.tarot.com/images/feeds/380x235/${image_slug}-380x235.jpg`;
        const url = article.page_type == 'folder' ? `/articles${article.custom_url}` : article.url;

        return (
            <a
                href={url}
                onClick={() => this.props.trackEvent([
                    'Article Collection: Nav',
                    'Click',
                    `Articles:${article.title}`,
                    `AC:${article.title}`,
                ])}
            >
                <img
                    alt={article.image_alt}
                    src={img_url}
                    loading={index > 9 ? 'lazy' : 'eager'}
                    height='235'
                    width='380'
                />
                <p>{article.title}</p>
            </a>
        );
    }

    getMostVisibleElement = () => {
        let clientRect = null;
        let clientRectTop = 0;
        let maxVisibleHeight = 0;
        let visibleHeightOfElem = 0;
        let mostVisibleElement = document.querySelector('pager[data-page="1"]');
        let skipRest = false;

        document.querySelectorAll('pager').forEach(pager => {
            if (skipRest === false) {
                clientRect = pager.getBoundingClientRect();
                clientRectTop = Math.abs(clientRect.top);

                if (clientRect.top >= 0) {
                    visibleHeightOfElem = window.innerHeight - clientRectTop;
                } else {
                    visibleHeightOfElem = clientRect.height - clientRectTop;
                }

                if (visibleHeightOfElem >= clientRect.height) {
                    mostVisibleElement = pager;
                    skipRest = true;
                } else {
                    if (visibleHeightOfElem > maxVisibleHeight) {
                        maxVisibleHeight = visibleHeightOfElem;
                        mostVisibleElement = pager;
                    }
                }

            }
        });

        return mostVisibleElement;
    }

    getScrollHeight = () => {
        return Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.body.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight,
            document.documentElement.clientHeight
        );
    }
}

const mapStateToProps = (state) => ({
    articles: state.articles && state.articles.list,
    page: state.articles && state.articles.page,
    pages: state.articles && state.articles.pages,
});

const mapDispatchToProps = (dispatch) => ({
    getPage: (payload) => dispatch({
        type: 'articles:get-page',
        payload: payload,
    }),
    setPage: (payload) => dispatch({
        type: 'articles:set-page',
        payload: payload,
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
